export default "__VITE_ASSET__Djm7gQPu__"